import { render, staticRenderFns } from "./prefectures.vue?vue&type=template&id=18cb9ad5&scoped=true"
import script from "./prefectures.vue?vue&type=script&lang=js"
export * from "./prefectures.vue?vue&type=script&lang=js"
import style0 from "./prefectures.vue?vue&type=style&index=0&id=18cb9ad5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cb9ad5",
  null
  
)

export default component.exports